import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/legal/legal-page";
import { NOTICES } from "@/lib/legal";

export const Route = createFileRoute("/notices")({
  component: () => <LegalPage doc={NOTICES} />,
});
